import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ArrowClockwise } from '@phosphor-icons/react';

const PullToRefresh = ({ onRefresh, children }) => {
  const [pulling, setPulling] = useState(false);
  const [pullDistance, setPullDistance] = useState(0);
  const startY = useRef(0);
  const threshold = 80;

  const handleTouchStart = (e) => {
    if (window.scrollY === 0) {
      startY.current = e.touches[0].clientY;
    }
  };

  const handleTouchMove = (e) => {
    if (window.scrollY === 0 && startY.current) {
      const currentY = e.touches[0].clientY;
      const distance = currentY - startY.current;
      
      if (distance > 0) {
        setPullDistance(Math.min(distance, threshold + 20));
        setPulling(distance > threshold);
      }
    }
  };

  const handleTouchEnd = async () => {
    if (pulling && pullDistance > threshold) {
      await onRefresh();
    }
    setPullDistance(0);
    setPulling(false);
    startY.current = 0;
  };

  return (
    <div
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      className="relative"
    >
      {/* Pull Indicator */}
      {pullDistance > 0 && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: pullDistance / threshold }}
          className="absolute top-0 left-0 right-0 flex justify-center pt-4 z-10"
          style={{ transform: `translateY(${Math.min(pullDistance, threshold)}px)` }}
        >
          <div className="bg-white rounded-full p-2 shadow-md">
            <motion.div
              animate={{ rotate: pulling ? 360 : 0 }}
              transition={{ duration: 0.5, repeat: pulling ? Infinity : 0, ease: 'linear' }}
            >
              <ArrowClockwise size={24} weight="bold" className="text-[#659A9B]" />
            </motion.div>
          </div>
        </motion.div>
      )}
      
      <div style={{ transform: `translateY(${Math.min(pullDistance * 0.5, threshold * 0.5)}px)` }}>
        {children}
      </div>
    </div>
  );
};

export default PullToRefresh;